// extracted by mini-css-extract-plugin
export var back = "header-module--back--27AJe";
export var HeaderTitle = "header-module--HeaderTitle--3rtQw";